import { useStaticQuery, graphql } from "gatsby"

const useWoodsProductQuery = () => {
  const { allDatoCmsWoodsProduct } = useStaticQuery(graphql`
    query WoodsProducts {
      allDatoCmsWoodsProduct(
        filter: {hideForLocale: {ne: true}}, 
        sort: {position: ASC}
      ) {
        nodes {
          id
          originalId
          title
          brand
          slug
          permalink
          header
          size
          category: woodsProductCategories {
            title
          }
          gallery {
            ...InternalAssetProps
          }
        }
      }
    }
  `)
  return allDatoCmsWoodsProduct.nodes
}

export default useWoodsProductQuery